<div class="date-range-wrapper" ngClass="{{ class }}">
  <mat-date-range-input [formGroup]="periodGroup" [rangePicker]="rangePicker">
    <input
      autocomplete="off"
      matStartDate
      formControlName="from"
      placeholder="mm/dd/yyyy"
    />
    <input
      autocomplete="off"
      matEndDate
      formControlName="to"
      placeholder="mm/dd/yyyy"
    />
  </mat-date-range-input>
  <i class="material-icons range-icon" (click)="rangePicker.open()"> today </i>
  <i class="material-icons range-icon" (click)="rangePicker.open()"> today </i>
</div>
<mat-date-range-picker #rangePicker></mat-date-range-picker>
